export const CHAT_TRANSFERENCIA_STORAGE_KEY = 'chatTransferenciaNumeroContatoFiltro';
export const CONTATO_DISPARO_FILTRO_SESSION_KEY = 'contatoDisparoBuscaFiltro';
export const ROTA_TELA_CONTATOS = '/contato';
